"use strict";
module.exports = {
    SYSTEM_JOB_TYPE: {
        FULL_SYNC: 'FULL_SYNC',
        DELTA_SYNC: 'DELTA_SYNC',
        DELTA_DAILY_SYNC: 'DELTA_DAILY_SYNC',
    },
    SYSTEM_JOB_STATUS: {
        FAILED: 'FAILED',
        PENDING: 'PENDING',
        RUNNING: 'RUNNING',
        SUCCESS: 'SUCCESS',
        SUCCESS_WITH_ERRORS: 'SUCCESS_WITH_ERRORS',
    },
    SYSTEM_JOB_TASK_STATUS: {
        FAILED: 'FAILED',
        PENDING: 'PENDING',
        RUNNING: 'RUNNING',
        SUCCESS: 'SUCCESS',
        SUCCESS_WITH_ERRORS: 'SUCCESS_WITH_ERRORS',
    },
    SYSTEM_JOB_TASK_TYPE: {
        //FULL SYNC
        GET_ACCOUNTS: 'GET_ACCOUNTS',
        GET_BANK_TRANSACTIONS: 'GET_BANK_TRANSACTIONS',
        GET_CONTACTS: 'GET_CONTACTS',
        GET_CREDIT_NOTES: 'GET_CREDIT_NOTES',
        GET_EXPENSE_CLAIMS: 'GET_EXPENSE_CLAIMS',
        GET_INVOICES: 'GET_INVOICES',
        GET_INVOICE_LINKED_TRANSACTIONS: 'GET_INVOICE_LINKED_TRANSACTIONS',
        GET_ORGANIZATION: 'GET_ORGANIZATION',
        GET_OVERPAYMENTS: 'GET_OVERPAYMENTS',
        GET_PAYMENTS: 'GET_PAYMENTS',
        GET_PREPAYMENTS: 'GET_PREPAYMENTS',
        GET_RECEIPTS: 'GET_RECEIPTS',
        GET_REPORT_PROFIT_AND_LOSS: 'GET_REPORT_PROFIT_AND_LOSS',
        GET_REPORT_REPORT_BANK_SUMMARY: 'GET_REPORT_REPORT_BANK_SUMMARY',
        GET_TAX_RATES: 'GET_TAX_RATES',
        GET_USERS: 'GET_USERS',
        //DELTA DAILY SYNC
        DELTA_DAILY_GET_ACCOUNTS: 'DELTA_DAILY_GET_ACCOUNTS',
        DELTA_DAILY_GET_BANK_TRANSACTIONS: 'DELTA_DAILY_GET_BANK_TRANSACTIONS',
        DELTA_DAILY_GET_CONTACTS: 'DELTA_DAILY_GET_CONTACTS',
        DELTA_DAILY_GET_CREDIT_NOTES: 'DELTA_DAILY_GET_CREDIT_NOTES',
        DELTA_DAILY_GET_EXPENSE_CLAIMS: 'DELTA_DAILY_GET_EXPENSE_CLAIMS',
        DELTA_DAILY_GET_INVOICES: 'DELTA_DAILY_GET_INVOICES',
        DELTA_DAILY_GET_INVOICE_LINKED_TRANSACTIONS: 'DELTA_DAILY_GET_INVOICE_LINKED_TRANSACTIONS',
        DELTA_DAILY_GET_ORGANIZATION: 'DELTA_DAILY_GET_ORGANIZATION',
        DELTA_DAILY_GET_OVERPAYMENTS: 'DELTA_DAILY_GET_OVERPAYMENTS',
        DELTA_DAILY_GET_PAYMENTS: 'DELTA_DAILY_GET_PAYMENTS',
        DELTA_DAILY_GET_PREPAYMENTS: 'DELTA_DAILY_GET_PREPAYMENTS',
        DELTA_DAILY_GET_RECEIPTS: 'DELTA_DAILY_GET_RECEIPTS',
        DELTA_DAILY_GET_REPORT_PROFIT_AND_LOSS: 'DELTA_DAILY_GET_REPORT_PROFIT_AND_LOSS',
        DELTA_DAILY_GET_REPORT_BANK_SUMMARY: 'DELTA_DAILY_GET_REPORT_BANK_SUMMARY',
        DELTA_DAILY_GET_TAX_RATES: 'DELTA_DAILY_GET_TAX_RATES',
        DELTA_DAILY_GET_USERS: 'DELTA_DAILY_GET_USERS',
        //DELTA HALF HOURLY SYNC
        DELTA_HALF_HOURLY_GET_ACCOUNTS: 'DELTA_HALF_HOURLY_GET_ACCOUNTS',
        DELTA_HALF_HOURLY_GET_BANK_TRANSACTIONS: 'DELTA_HALF_HOURLY_GET_BANK_TRANSACTIONS',
        DELTA_HALF_HOURLY_GET_CONTACTS: 'DELTA_HALF_HOURLY_GET_CONTACTS',
        DELTA_HALF_HOURLY_GET_CREDIT_NOTES: 'DELTA_HALF_HOURLY_GET_CREDIT_NOTES',
        DELTA_HALF_HOURLY_GET_EXPENSE_CLAIMS: 'DELTA_HALF_HOURLY_GET_EXPENSE_CLAIMS',
        DELTA_HALF_HOURLY_GET_INVOICES: 'DELTA_HALF_HOURLY_GET_INVOICES',
        DELTA_HALF_HOURLY_GET_INVOICE_LINKED_TRANSACTIONS: 'DELTA_HALF_HOURLY_GET_INVOICE_LINKED_TRANSACTIONS',
        DELTA_HALF_HOURLY_GET_ORGANIZATION: 'DELTA_HALF_HOURLY_GET_ORGANIZATION',
        DELTA_HALF_HOURLY_GET_OVERPAYMENTS: 'DELTA_HALF_HOURLY_GET_OVERPAYMENTS',
        DELTA_HALF_HOURLY_GET_PAYMENTS: 'DELTA_HALF_HOURLY_GET_PAYMENTS',
        DELTA_HALF_HOURLY_GET_PREPAYMENTS: 'DELTA_HALF_HOURLY_GET_PREPAYMENTS',
        DELTA_HALF_HOURLY_GET_RECEIPTS: 'DELTA_HALF_HOURLY_GET_RECEIPTS',
        DELTA_HALF_HOURLY_GET_REPORT_PROFIT_AND_LOSS: 'DELTA_HALF_HOURLY_GET_REPORT_PROFIT_AND_LOSS',
        DELTA_HALF_HOURLY_GET_REPORT_BANK_SUMMARY: 'DELTA_HALF_HOURLY_GET_REPORT_BANK_SUMMARY',
        DELTA_HALF_HOURLY_GET_TAX_RATES: 'DELTA_HALF_HOURLY_GET_TAX_RATES',
        DELTA_HALF_HOURLY_GET_USERS: 'DELTA_HALF_HOURLY_GET_USERS',
    },
    SYSTEM_JOB_TASK_ERROR_RESOLUTION_STATUS: {
        UNRESOLVED: 'UNRESOLVED',
        RESOLVED: 'RESOLVED',
        ARCHIVED: 'ARCHIVED',
    },
    SYSTEM_JOB_TASK_ERROR_IDENTIFIERS: {
        INVALID_OAUTH_TOKEN: 'INVALID_OAUTH_TOKEN',
    },
};
